import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExitToApp from '@material-ui/icons/ExitToApp'
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import StoreIcon from '@material-ui/icons/Store';
import EditIcon from '@material-ui/icons/Edit';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PersonPinIcon from '@material-ui/icons/PersonPinCircle';
import Avatar from '@material-ui/core/Avatar';

import Checkbox from '@material-ui/core/Checkbox';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MotorcycleIcon from '@material-ui/icons/Motorcycle';
import PaymentIcon from '@material-ui/icons/Payment';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import FaceIcon from '@material-ui/icons/Face';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';

import _ from "lodash";
import firebase from '../../Firebase';
import AsyncStorage from '@callstack/async-storage';
import moment from 'moment';
import Mainmenu from '../../components/mainmenu';

const drawerWidth = 240;

const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit,
  },
}))(MuiDialogActions);

const styles = theme => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#f2a811',
      borderRadius: '5px',
    }
  },
  hide: {
    display:'none',
  },
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    backgroundColor: '#f2a811',
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  toolbarAvatar: {
    borderRadius: 0,
    width: 170,
    left: 10,
  },
  toolbarIconButton:{
    right:0,
    position:'absolute'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto',
  },
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
  loadingColorPrimary: {
    backgroundColor: '#f2a811',
  },
  loadingBarColorPrimary: {
    backgroundColor: '#b1730d',
  },
  userAvatar:{
    backgroundColor: '#b1730d',
  },
  button: {
    color: '#fff',
    backgroundColor: '#f2a811',
    '&:hover': {
      backgroundColor: '#b1730d',
    },
  },
  input: {
    '&:after': {
      borderBottomColor: '#f2a811',
    },
  },
  checkbox: {
    color: '#f2a811',
    '&$checked': {
      color: '#f2a811',
    },
  },
  table: {
    display: 'block',
    width: '100%',
    overflowX: 'auto',
  },
  buttonProgress: {
    color: "#fff",
  },
  select: {
    width: '100%',
    '&:after': {
      borderBottomColor: '#f2a811',
    },
  },
  avatar:{
    backgroundColor: '#b1730d',
  },
  div_100p:{
    width: "100%",
    marginTop: 15,
    marginBottom: 15,
  },
  color_b1730d:{
    color:"#b1730d"
  }
});

class Orders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      saving: false,
      assigning_rider: false,
      user: {},
      drawer: true,
      config:{},
      users:[],
      orders:[],
      order:{},
      searchedTxt: "",
      searchedArr: [],
      dialog: false,
      dialogType: "",
      dateFilter: new Date(), //moment().format('YYYY-MM-DD'),
      dateFilterStr: "custom",
      menus: [],
      anchorEl: null,
      activeRider:"",
      checkedOrders:[],
      unfilteredOrders: []
    }
  }

  componentWillMount(){
    AsyncStorage.getItem("user").then(u => {
      if (u) {
        const t = this;
        let user = JSON.parse(u);
       
        firebase.firestore().collection("config").get().then(snapshot => {
          t.setState({config:JSON.parse(snapshot.docs[0]._document.data.toString()), user:user});
        });

        firebase.firestore().collection('users').onSnapshot(function(docs) {
          let users = [];
        
          docs.forEach(doc => {
            let user = JSON.parse(doc._document.data.toString());
            user.id = doc.id
            users.push(user);
          });
          t.setState({users:users});
        });

        this.getOrders()

       

      } else
        this.props.navigation.navigate('Login');
    });
  }

  async logout(){
    try {
      //await AsyncStorage.removeItem('user');
      this.props.navigation.navigate('Login');
    } catch (error) {
      console.log(error);
    }
  }

  getLastOrders(){

    let t = this
    let lastDate = this.state.dateFilterStr
    let start = new Date(this.state.dateFilter)
     
    if(lastDate=="5_days")
       start.setDate(start.getDate()-5)
    else if(lastDate=="30_days")
       start.setDate(start.getDate()-30)
    else if(lastDate=="3_months")
       start.setDate(start.getMonth()-3)
    else if(lastDate=="6_months")
       start.setDate(start.getMonth()-6)  
    else if(lastDate=="12_months")
       start.setDate(start.getMonth()-12)  
     
     let end = new Date()
     end.setDate(end.getDate()+1);
     console.log('dateFilter', this.state.dateFilter);
     console.log('start', start);
     console.log('end', end);
     firebase.firestore().collection('orders')
      .where('created_at','>', start )
      .where('created_at','<', end )
      .onSnapshot(function(docs) {
          let orders = [];

          docs.forEach(doc => {
            let order = JSON.parse(doc._document.data.toString());
            console.log('order',order)
            order.doc_id = doc.id;
            orders.push(order);
          });
          t.setState({unfilteredOrders: orders, orders:orders, loading:false});
        });


  }

  getOrders(){
     let t = this
     let start = new Date(this.state.dateFilter)
     start.setDate(start.getDate()-1)
     
     let end = new Date(this.state.dateFilter)
     end.setDate(end.getDate()+1);
     console.log('dateFilter', this.state.dateFilter);
     console.log('start', start);
     console.log('end', end);
     firebase.firestore().collection('orders')
      .where('created_at','>', start )
      .where('created_at','<', end )
      .onSnapshot(function(docs) {
          let orders = [];

          docs.forEach(doc => {
            let order = JSON.parse(doc._document.data.toString());
            console.log('order',order)
            order.doc_id = doc.id;
            orders.push(order);
          });
          t.setState({unfilteredOrders: orders, orders:orders, loading:false});
        });


  }

  onSearch(s){
   
    if(s!=''){
      let ord = []
       ord = _.filter(this.state.unfilteredOrders, function(o) { 
        return o.order_id.toLowerCase().includes(s.toLowerCase()) 
        || (o.orderStatus+"").toLowerCase().includes(s.toLowerCase())
        || (o.address+"").toLowerCase().includes(s.toLowerCase())
        || (o.deliveryDate+"").toLowerCase().includes(s.toLowerCase())
        || (o.deliveryTime+"").toLowerCase().includes(s.toLowerCase())
        || (o.subtotal+"").toLowerCase().includes(s.toLowerCase())
      });

      this.setState({orders: ord})
    }else{
         this.setState({orders: this.state.unfilteredOrders})
    }
   
  }


  onSave(){
    const t = this;
    t.setState({saving:true});

    firebase.firestore().collection('orders').doc(t.state.order.doc_id).update({
      cart:t.state.order.cart,
    }).then(() => {
      t.toggleDialog(false, "cart", t.state.order);
    }).catch( error => {
      console.log(error);
      t.toggleDialog(false, "cart", t.state.order);
    });
  }

  onAssignRider(){
    const t = this;
    t.setState({assigning_rider:true});
    
    if(t.state.activeRider != ""){

      console.log('checkedOrders',t.state.checkedOrders)
      let checkedOrders = t.state.checkedOrders;
        let updatedOrders = 0;
        checkedOrders.map((c, i) => {
          firebase.firestore().collection('orders').doc(c).update({
            rider:t.state.activeRider,
          }).then(() => {
            updatedOrders++;
            if(updatedOrders == checkedOrders.length)
              t.toggleDialog(false, "cart", {});
          }).catch( error => {
            console.log(error);
            t.toggleDialog(false, "cart", {});
          });
        });

      /*if(t.state.dialogType == "rider_multiple"){
        let checkedOrders = t.state.checkedOrders;
        let updatedOrders = 0;
        checkedOrders.map((c, i) => {
          firebase.firestore().collection('orders').doc(c).update({
            rider:t.state.activeRider,
          }).then(() => {
            updatedOrders++;
            if(updatedOrders == checkedOrders.length)
              t.toggleDialog(false, "cart", {});
          }).catch( error => {
            console.log(error);
            t.toggleDialog(false, "cart", {});
          });
        });
      } else{
        firebase.firestore().collection('orders').doc(t.state.order.doc_id).update({
          rider:t.state.activeRider,
        }).then(() => {
          t.toggleDialog(false, "cart", t.state.order);
        }).catch( error => {
          console.log(error);
          t.toggleDialog(false, "cart", t.state.order);
        });
      }*/
    }
  }

  toggleDrawer(){
    this.setState({ drawer:!this.state.drawer });
  }

  toggleDialog(bool, type, obj){
    if(type == "rider_multiple")
      this.setState({ dialog:bool, dialogType:bool ? type : "", order:{}, activeRider:"", saving:false, assigning_rider:false });
    if(type == "rider")
      this.setState({ dialog:bool, dialogType:bool ? type : "", order:bool ? obj : {}, activeRider:bool ? obj.rider : "", saving:false, assigning_rider:false, checkedOrders:[] });
    if(type == "cart")
      this.setState({ dialog:bool, dialogType:bool ? type : "", order:bool ? obj : {}, activeRider:bool ? obj.rider : "", saving:false, assigning_rider:false });
  }

  toggleMenu(event, i, bool){
    var menus = this.state.menus;
    menus[i] = bool;
    this.setState({menus:menus, anchorEl:(bool ? event.currentTarget : null )});
  }

  checkCart(cart){
    let ready = 0;
    cart.map((c, i) => {
      if(c.item.for_delivery)
        ready++;
    });
    if(ready == 0)
      return false;
    else
      return true;
  }

  goTo(p){
    this.props.navigation.navigate(p);
  }

  checkOrderTableRows(otr){
    let totalUndefined = 0;

    otr.map(o => {
      if(o == undefined)
        totalUndefined++;
    });

    if(otr.length == totalUndefined)
      return true
    else
      return false
  }

  render() {
    const { classes } = this.props;
    let dateFilter = this.state.dateFilter;
    let orders = this.state.orders;
    let users = this.state.users;
    let order = this.state.order;
    let checkedOrders = this.state.checkedOrders;
    let orderTableRows;
    let orderItemRows;
    let riderTableRows;
    let totalOrders = this.state.orders.length

    let completedOrders = _.filter(this.state.orders, function(o) { 
        return o.orderStatus === "COMPLETE"   
      });

    let salesOrders = _.filter(this.state.unfilteredOrders, function(o) { 
        return o.orderStatus === "COMPLETE"   
      });

    let pendingOrders = _.filter(this.state.orders, function(o) { 
        return o.orderStatus === "PENDING"   
      });

    let totalSales = _.sumBy(salesOrders, 'subtotal')

    if(!_.isEmpty(users)){
      riderTableRows = users.map((u, i) => {
        if(u.roles.includes("rider")){
            return (
            <TableRow key={i}>
              <TableCell component="th" scope="row">
                { u.selfie == "" ?
                  <Avatar className={classes.avatar}>
                    <MotorcycleIcon />
                  </Avatar>
                :
                  <Avatar alt={u.firstName+' '+u.middleName+' '+u.lastName} src={u.selfie} />
                }
              </TableCell>
              <TableCell component="th" scope="row">{ u.firstName+" "+u.lastName }</TableCell>
              <TableCell component="th" scope="row">
                <Checkbox value={u.id} color="#f2a811" checked={this.state.activeRider == u.id ? true : false} className={classes.checkbox}
                  onChange={event => {
                    this.setState({activeRider:this.state.activeRider == u.id ? "" : event.target.value});
                  }}
                />
              </TableCell>
            </TableRow>
          );
        }
      });
    }

    
    
    if(!_.isEmpty(order)){
      orderItemRows = order.cart.map((c, i) => {
        let item = c.item;
        return (
          <TableRow key={i}>
            <TableCell component="th" scope="row">
              <Avatar src={item.itemImage} />
            </TableCell>
            <TableCell component="th" scope="row">{item.item}</TableCell>
            <TableCell component="th" scope="row">{'₱ '+item.seller_price}</TableCell>
            <TableCell component="th" scope="row">{c.quantity}</TableCell>
            <TableCell component="th" scope="row">
              <Checkbox value={i} color="#f2a811" checked={item.for_delivery} className={classes.checkbox}
                onChange={event => {
                  order.cart[event.target.value].item.for_delivery = !order.cart[event.target.value].item.for_delivery;
                  this.setState({order:order});
                }}
              />
            </TableCell>
          </TableRow>
        );
      });
    }

    if(!_.isEmpty(orders) ){
      /*if(this.state.searchedTxt != "")
        orders = this.state.searchedArr;
*/
      orderTableRows = orders.map((o, i) => {
        let privilege;
        let user;
        
        /*users.map(u => {
          if(o.user == u.id)
            user = u;
        });*/

        /*if(this.state.user.roles.includes("admin"))
          privilege = "admin";
        else if(!this.state.user.roles.includes("admin") && this.state.user.roles.includes("seller"))
          privilege = "seller";*/

        let c = [
          <TableRow key={i}>
            <TableCell component="th" scope="row">
              <Checkbox value={o.doc_id} color="#f2a811" checked={checkedOrders.indexOf(o.doc_id) > -1 ? true : false} className={classes.checkbox}
                onChange={event => {
                  if (checkedOrders.indexOf(o.doc_id) > -1)
                    checkedOrders.splice(checkedOrders.indexOf(o.doc_id), 1);
                  else
                    checkedOrders.push(o.doc_id);
                  this.setState({checkedOrders:checkedOrders});
                }}
              />
            </TableCell>
            <TableCell component="th" scope="row">{ o.order_id }</TableCell>
            <TableCell component="th" scope="row">{ o.orderStatus }</TableCell>
            <TableCell component="th" scope="row">{ o.address }</TableCell>
            <TableCell component="th" scope="row">{ o.deliveryDate+', '+o.deliveryTime }</TableCell>
            <TableCell component="th" scope="row">{ '₱ '+o.subtotal }</TableCell>
            <TableCell component="th" scope="row">
              <IconButton
                aria-label="More"
                aria-owns={this.state.menus[i] ? 'render-props-menu-'+i : undefined}
                aria-haspopup="true"
                onClick={(e) => this.toggleMenu(e, i, true)}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu id={"render-props-menu-"+i} open={this.state.menus[i]} anchorEl={this.state.anchorEl} onClose={(e) => this.toggleMenu(e, i, false)}>
                <MenuItem onClick={() => this.toggleDialog(true, "cart",o)}>
                  <ListItemIcon><ShoppingCartIcon /></ListItemIcon>
                  <Typography variant="inherit" noWrap>View Cart</Typography>
                </MenuItem>
                {

                /*
                <MenuItem onClick={() => this.toggleDialog(true, "rider", o)}>
                  <ListItemIcon><MotorcycleIcon /></ListItemIcon>
                  <Typography variant="inherit" noWrap>Assign Rider</Typography>
                </MenuItem>
                 privilege == "seller" &&
                  <MenuItem onClick={() => {}}>
                    <ListItemIcon><PaymentIcon /></ListItemIcon>
                    <Typography variant="inherit" noWrap>Payout</Typography>
                  </MenuItem>
                */

                }
                <MenuItem onClick={(e) => this.toggleMenu(e, i, false)}>
                  <ListItemIcon><CloseIcon /></ListItemIcon>
                  <Typography variant="inherit" noWrap>Close</Typography>
                </MenuItem>
              </Menu>
            </TableCell>
          </TableRow>
        ];

        return (c)
        /*if(this.state.dateFilter == moment(o.deliveryDate).format('YYYY-MM-DD')){
          if(privilege == "admin")
            return (c);
          if(privilege == "seller"){
            o.cart.map((crt, i) => {
              if(crt.item.seller == this.state.user.id)
                return (c);
            });
          }
        }*/
      });
    }

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, this.state.drawer && classes.appBarShift)}
        >
          <Toolbar disableGutters={!this.state.drawer} className={classes.toolbar}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={() => this.toggleDrawer()}
              className={classNames(
                classes.menuButton,
                this.state.drawer && classes.menuButtonHidden,
              )}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
            >
              Orders
            </Typography>
            <IconButton color="inherit" onClick={() => this.logout()}>
              <ExitToApp />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper, !this.state.drawer && classes.drawerPaperClose),
          }}
          open={this.state.drawer}
        >
          <div className={classes.toolbarIcon}>
            <Avatar src="https://firebasestorage.googleapis.com/v0/b/easysuki-dev.appspot.com/o/assets%2FeasySuki-toolbar.png?alt=media&token=3b713ebc-804c-4e5f-8362-aa5d48f5ff29" className={classes.toolbarAvatar}/>
            <IconButton onClick={() => this.toggleDrawer()} className={classes.toolbarIconButton}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <Mainmenu navigation={this.props.navigation} active="orders" />
          
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          {/*<Typography variant="h4" gutterBottom component="h2">
            Orders
          </Typography>
          <Typography component="div" className={classes.chartContainer}>
            <SimpleLineChart />
          </Typography>
          <Typography variant="h4" gutterBottom component="h2">
            Products
          </Typography>*/}
          <div className={classes.tableContainer}>
            { !this.state.loading &&
              [
                <Grid container spacing={24}>
                  <Grid key={0} item xs={12} sm={12} md={_.isEmpty(checkedOrders) ? 8 : 6} lg={_.isEmpty(checkedOrders) ? 8 : 6}>
                    <FormControl fullWidth className={classes.margin}>
                      <Input
                        placeholder="Search"
                        className={classes.input}
                        onChange={event => this.onSearch(event.target.value)}
                        startAdornment={<InputAdornment position="start"><SearchIcon/></InputAdornment>}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2}>
                    <Select
                      value={this.state.dateFilterStr}
                      className={classes.select}
                      startAdornment={<InputAdornment position="start"><CalendarIcon/></InputAdornment>}
                      onChange={(event) => {
                        let val = event.target.value;
                        if(val == "custom")
                          this.setState({dateFilterStr:val}, ()=>{
                            this.getOrders()
                          });
                        else
                          this.setState({dateFilterStr:val }, ()=>{
                            this.getLastOrders();
                          });
                      }}
                      inputProps={{
                        name: 'filter-by',
                        id: 'filter-by',
                      }}
                    >
                      <MenuItem value={"custom"}>Custom Date</MenuItem>
                      <MenuItem value={"5_days"}>{"Last 5 days"}</MenuItem>
                      <MenuItem value={"30_days"}>{"Last 30 days"}</MenuItem>
                      <MenuItem value={"3_months"}>{"Last 3 Months"}</MenuItem>
                      <MenuItem value={"6_months"}>{"Last 6 Months"}</MenuItem>
                      <MenuItem value={"12_months"}>{"Last 12 Months"}</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2}>
                    <Input
                      disabled={this.state.dateFilterStr == "custom" ? false : true }
                      value={this.state.dateFilter}
                      type="date"
                      placeholder="Date"
                      className={classes.select}
                      onChange={(event) => {
                         this.setState({dateFilter:event.target.value},
                          ()=>{
                            this.getOrders(this.state.dateFilter)
                          })
                         
                        }
                       }
                      startAdornment={<InputAdornment position="start"><CalendarIcon/></InputAdornment>}
                    />
                  </Grid>
                  { !_.isEmpty(checkedOrders) &&
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                      <Button
                        fullWidth
                        variant="contained"
                        className={classes.button}
                        onClick={() => this.toggleDialog(true, "rider_multiple")}
                      >
                        Assign Rider
                      </Button>
                    </Grid>
                  }
                </Grid>,
                <br key={1} />,
              ]
            }
            { this.state.loading ?
                <Paper className={classes.root}>
                  <Table className={classes.table}>
                    <LinearProgress
                      classes={{
                        colorPrimary: classes.loadingColorPrimary,
                        barColorPrimary: classes.loadingBarColorPrimary,
                      }}
                    />
                  </Table>
                </Paper>
              :
              <div>
                <br/>
                <Grid key={2} container spacing={24}>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Paper>
                      <center>
                        {"Total Orders"}
                        <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                          { totalOrders }
                        </Typography>
                      </center>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Paper>
                      <center>
                        {"Completed Orders"}
                        <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                          { completedOrders.length }
                        </Typography>
                      </center>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Paper>
                      <center>
                        {"Pending Orders"}
                        <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                          {pendingOrders.length}
                        </Typography>
                      </center>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Paper>
                      <center>
                        {"Total Sales"}
                        <Typography className={classes.color_b1730d} component="h2" variant="display1" gutterBottom>
                          ₱{ Number(totalSales).toLocaleString() }
                        </Typography>
                      </center>
                    </Paper>
                  </Grid>
                  
                </Grid>
                <br/>
                <Paper className={classes.root}>
                   <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>Order ID</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Address</TableCell>
                            <TableCell>Delivery Date & Time</TableCell>
                            <TableCell>Subtotal</TableCell>
                            <TableCell>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {orderTableRows}
                        </TableBody>
                      </Table>
                </Paper>
              </div>
            }
          </div>
        </main>
        <Dialog
          onClose={() => {this.setState({dialog:false})}}
          aria-labelledby="customized-dialog-title"
          open={this.state.dialog}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
            { this.state.dialogType == "cart" ? !_.isEmpty(order) && "Order "+order.order_id : "Assign Rider" }
          </DialogTitle>
          <DialogContent>
            <div>
              { this.state.dialogType == "cart" ?
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Item</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Price</TableCell>
                        <TableCell>Quantity</TableCell>
                        <TableCell>Ready for Delivery</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      { orderItemRows }
                    </TableBody>
                  </Table>
                :
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Assign</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      { riderTableRows }
                    </TableBody>
                  </Table>
              }
            </div>
          </DialogContent>
          <DialogActions>
            { this.state.dialogType == "cart" && this.checkCart(order.cart) &&
              <Button className={classes.button} onClick={() => this.onSave()} color="primary">
                { this.state.saving ?
                    <CircularProgress size={24} className={classes.buttonProgress} />
                  :
                    "Ready for delivery"
                }
              </Button>
            }
            { this.state.dialogType == "rider" || this.state.dialogType == "rider_multiple" && this.state.activeRider != "" &&
              <Button className={classes.button} onClick={() => this.onAssignRider()} color="primary">
                { this.state.assigning_rider ?
                    <CircularProgress size={24} className={classes.buttonProgress} />
                  :
                    "Assign Rider"
                }
              </Button>
            }
            <Button className={classes.button} onClick={() => this.toggleDialog(false, "cart", this.state.order)} color="primary">Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Orders.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Orders);